module.exports = __webpack_public_path__ + "fonts/fa-v2-solid-900.0fe9b01b.ttf";